import Departamentos from '@/components/ADepartamentos.vue'
import Ciudades from '@/components/ACiudades.vue'
import Universidades from '@/components/AUniversidades.vue'
import Profesiones from '@/components/AProfesiones.vue'
import AEstudianteByDoc from '@/components/AEstudianteByDoc.vue'
import Grados from '@/components/AGrados.vue'
import Empresas from '@/components/AEmpresas.vue'
import Alertas from '@/components/AAlertas.vue'
import Fecha from '@/components/AFecha.vue'
import { Validator } from 'simple-vue-validator'
import gql from 'graphql-tag'
import { parseJsonError } from '@/components/Utils.js'

export default {
    props: {
        //inscripcion:{type:Object,required:true},
    },
    data() {
        return {
            activo: true,
            preinscribir: true,
            msg: '',
            programa: {},
            newEstudiante: {
                num_doc: null,
                nombres: null,
                pri_apellido: null,
                email: null,
                sexo: null,
                tipo: "D",
                diestro: true,
                profesiones: [],

                idempresa: null,
                grados: [],
                idinstitucion: null,
                iddepartamento: null,
                idciudad: null,
                contacto: null,
                domicilio: null,
                datos_laborales: null,
                est_civil: null,
                fecha_nac: null,
                telefono2: null,
                telefono1: null,
                seg_apellido: null,
                usuario_moodle: null,
                clave_moodle: null,

                //este no esta, debe ser concatenado a datos laborales
                cargo: null,
            },
            cuotas: [],
        }
    },
    components: { Departamentos, Ciudades, Universidades, Profesiones, Grados, Empresas, Alertas, Fecha, AEstudianteByDoc },
    validators: {
        // 'newEstudiante.num_doc'(value) { return Validator.value(value).required().minLength(6).regex("^[1-9]\\d{5,14}(\\-([A-Z0-9]{1,2}))?$"); },
        'newEstudiante.num_doc'(value) { return Validator.value(value).required(); },
        'newEstudiante.nombres'(value) { return Validator.value(value).required().minLength(3).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
        'newEstudiante.pri_apellido'(value) { return Validator.value(value).required().minLength(3).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
        'newEstudiante.email'(value) { return Validator.value(value).email().required(); },
        'newEstudiante.sexo'(value) { return Validator.value(value).required(); },
        'newEstudiante.profesiones'(value) { return Validator.value(value).required(); },
        'newEstudiante.iddepartamento'(value) { return Validator.value(value); },
        'newEstudiante.usuario_moodle'(value) { return Validator.value(value).minLength(4).required(); },
        'newEstudiante.clave_moodle'(value) { return Validator.value(value).minLength(4).required(); },

        'newEstudiante.telefono1'(value) { return Validator.value(value).digit(); },
        'newEstudiante.telefono2'(value) { return Validator.value(value).digit(); },
        'newEstudiante.seg_apellido'(value) { return Validator.value(value).minLength(0).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
        'newEstudiante.datos_laborales'(value) { return Validator.value(value).minLength(0).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
        'newEstudiante.cargo'(value) { return Validator.value(value).minLength(0).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
        'newEstudiante.contacto'(value) { return Validator.value(value).digit() },
        'newEstudiante.domicilio'(value) { return Validator.value(value).minLength(0).regex("^([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9])([a-zñáéíóúA-ZÁÉÍÓÚÑ 0-9 % # ° / : , ' \" “ ” - . _ & ()]+)$"); },
    },
    watch: {
        newEstudiante: {
            deep: true,
            handler(a) {
                if (a == null) return;
                this.$refs.alertar.reset();
                this.msg = '';
                this.preinscribir = true;
                window.sessionStorage.setItem('xnewEstudiante', JSON.stringify(this.newEstudiante));
            }
        },

        'newEstudiante.nombres': function () { this.crearLogin() },
        'newEstudiante.pri_apellido': function () { this.crearLogin() },
        'newEstudiante.seg_apellido': function () { this.crearLogin() },
        'newEstudiante.num_doc': function () { this.crearClave() },
        'newEstudiante.iddepartamento': function () { this.crearClave() },
    },
    methods: {
        crearLogin() {
            var a = this.newEstudiante.nombres;
            var ap = this.newEstudiante.pri_apellido;
            var am = this.newEstudiante.seg_apellido;
            var inicial = "";
            var aa = "";
            var mm = "";
            if (a && a.length > 0) { inicial = a.substring(0, 1); }
            if (ap && ap.length > 0) { aa = ap.replace(/\s+/g, ""); }
            if (am && am.length > 0) { mm = am.replace(/\s+/g, ""); }
            this.newEstudiante.usuario_moodle = inicial + aa + mm;
            this.newEstudiante.usuario_moodle = this.newEstudiante.usuario_moodle.toLowerCase()
        },
        crearClave() {
            var car = this.newEstudiante.num_doc;
            var ci = "";
            var dep = this.newEstudiante.iddepartamento;
            if (car && car.length > 0) ci = this.newEstudiante.num_doc;
            if (dep) ci = ci + this.newEstudiante.iddepartamento.extension;
            this.newEstudiante.clave_moodle = ci;
        },

        validarCamposEst() {
            if (!this.activo) return;
            this.activo = false;
            this.$validate().then((success) => {
                var obj = window.Object.assign({}, this.newEstudiante);
                if (success) {
                    var ids = [];
                    obj.profesiones.forEach(function (e) { ids.push(e.id) });
                    delete obj.profesiones;
                    obj.profesiones = ids;
                    this.simpleValues(obj);
                    this.$store.state.obj = obj;
                    this.$store.dispatch('quitarNulos');

                    window.console.log(window.stringifyObject(obj));
                    this.$refs.alertar.cargando();
                    this.enviarDAtos(obj);
                } else {
                    window.console.log(window.stringifyObject(obj));
                    this.$refs.alertar.invalido();
                    this.activo = true;
                }
            });
        },
        simpleValues(obj) {
            if (obj.idempresa != null) obj.idempresa = obj.idempresa.id;
            if (obj.iddepartamento != null) obj.iddepartamento = obj.iddepartamento.id;
            if (obj.idciudad != null) obj.idciudad = obj.idciudad.id;
            if (obj.iduniversidad != null) obj.idinstitucion = obj.iduniversidad.id;
            if (obj.datos_laborales != null) obj.datos_laborales = obj.cargo + ", " + obj.datos_laborales;
            if (obj.idgrado != null) {
                obj.grados = [];
                obj.grados.push({ idgrado: obj.idgrado.id, titulo: obj.idgrado.nombre })
            }
            else obj.datos_laborales = obj.cargo;
            delete obj.iduniversidad;
            delete obj.cargo;
            delete obj.idgrado;
        },
        parseLabel2(option) {
            if (option == null) return "";
            var seg = option.seg_apellido;
            if (seg == null) seg = "";
            return option.nombres + " " + option.pri_apellido + " " + seg + " -- Doc: " + option.num_doc;
        },
        enviarDAtos(obj) {
            var vue = this;
            var sql = gql`mutation{ createPersona(input:${window.stringifyObject(obj)}){ok,persona{id,num_doc,nombres,pri_apellido,seg_apellido},errors{message}} }`;
            vue.msg = '';
            window.console.log(sql);

            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                if (data.data.createPersona.ok) {
                    vue.$refs.alertar.success();
                    window.sessionStorage.setItem('xnewEstudiante', null);
                    this.activo = true;
                    //var us = data.data.createPersona.persona;
                    //vue.inscripcion.idestudiante = { id:us.id,nombre:vue.parseLabel2(us) }
                    setTimeout(function () {
                        window.$('#collapseExample').collapse('hide')
                        window.scrollTop({ top: 0, left: 0, behavior: 'smooth' });
                    }, 1000)
                    vue.msg = '';
                } else {
                    var errores = JSON.stringify(data.data.createPersona.errors);
                    var obj = JSON.parse(errores);
                    var vals = '';
                    obj.forEach(function (k) { vals += Object.values(k) + "-\n\t"; });
                    vue.msg = '';
                    vue.activo = true;
                    vue.$refs.alertar.invalido(vals);
                }

                window.console.log(data);
            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(JSON.stringify(error));
                this.$notify(parseJsonError(error))
            })
        }

    },
    mounted() {
    }

}